'use strict';

// ACHTUNG! required in order to return React objects
import React from 'react';

import * as enums from '@playbook-technologies/common-enums';
import circuitIcon from '/static/images/circuit-icon.svg';

export function getExerciseIcon(type, disabled, modal) {
  if (type === enums.Exercise.Type.Single.value) {
    if (disabled)
      return <span className="icon-single disabled text-2xl"></span>;
    return <span className="icon-single text-2xl "></span>;
  } else if (type === enums.Exercise.Type.Multiple.value) {
    if (modal) {
      return (
        <img
          className="w-6 h-6"
          src={circuitIcon}
          style={{ height: '21px', margin: '6px 0 0 9px' }}
        ></img>
      );
    }
    return (
      <img
        className="w-6 h-6"
        src={circuitIcon}
        style={{ height: '22px', margin: '-1px 0' }}
      ></img>
    );
  } else if (type === enums.Exercise.Type.YouTube.value) {
    if (disabled)
      return <span className="icon-youtube2 disabled text-2xl"></span>;
    return <span className="icon-youtube2"></span>;
  } else if (type === enums.Exercise.Type.Product.value) {
    if (disabled)
      return <span className="icon-product disabled text-2xl"></span>;
    return <span className="icon-product"></span>;
  } else if (type === enums.Exercise.Type.Nutrition.value) {
    if (disabled)
      return <span className=" icon-nutrition disabled text-2xl"></span>;
    return <span className="icon-nutrition"></span>;
  }
}

export default { getExerciseIcon };
